import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  message,
} from "antd";
import { callCreatePermission } from "../../../../config/api";
import { IPermission } from "../../../../types/backend";
import {
  ALL_METHOD,
  ALL_MODULES,
} from "../../../../utils/constants/permissions";

const AddPermission = (props: any): JSX.Element => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const showModal = () => {
    setOpen(true);
  };

  const onFinish = async (values: IPermission) => {
    setLoading(true);
    const result = await callCreatePermission(values);
    if (result.statusCode === 201) {
      setOpen(false);
      props.handleFetchPermission();
      message.success("create category success !");
    } else {
      message.error("create category failed !");
    }
    setLoading(false);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Spin spinning={loading}>
      <Button type="primary" onClick={showModal} icon={<PlusOutlined />}>
        Thêm mới
      </Button>
      <Modal
        title="Thêm phân quyền"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Tạo mới"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter name" }]}>
                <Input
                  placeholder="Please enter name"
                  style={{ height: "32px" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="apiPath"
                label="API Path"
                rules={[{ required: true, message: "Please enter apiPath" }]}>
                <Input
                  placeholder="Please enter apiPath"
                  style={{ height: "32px" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="method"
                label="Method"
                rules={[{ required: true, message: "Please enter method" }]}>
                <Select defaultValue="" options={ALL_METHOD} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="module"
                label="Thuộc Module"
                rules={[{ required: true, message: "Please enter module" }]}>
                <Select defaultValue="" options={ALL_MODULES} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default AddPermission;
